import { useMutation } from '@apollo/client';
import { INIT_FACEBOOK_AUTH } from 'api/social-media-connections/mutations';
import {
  InitFacebookAuth,
  InitFacebookAuthVariables,
} from 'api/social-media-connections/types/InitFacebookAuth';

export const useInitFacebookAuth = () => {
  return useMutation<InitFacebookAuth, InitFacebookAuthVariables>(
    INIT_FACEBOOK_AUTH
  );
};
